import React from 'react'
import introVideo from './Images/rowSix/introVideo.jpg'
import WhatWeDo from './Images/rowSix/whatwedo.jpg'
import TeamOne from './Images/rowSix/team/teamOne.jpg'
import TeamTwo from './Images/rowSix/team/teamTwo.jpg'
import TeamThree from './Images/rowSix/team/teamThree.jpg'
export default function AboutComapny() {
    return (
        <div>
            <div className="my-5">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div class="card" style={{ border: '0px' }} >
                            <img style={{ borderRadius: '0px' }} src={introVideo} class="card-img-top" alt="..." />
                            <div class="card-body" style={{ paddingTop: '30px', paddingLeft: '0px' }}>
                                <h5 style={{ color: '#333' }} class="card-title py-3">INTRO ABOUT COMPANY</h5>
                                <p style={{ color: "777" }} class="card-text para">Minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

                                <p style={{ color: "777" }} class="card-text para">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div class="card" style={{ border: '0px' }} >
                            <img style={{ borderRadius: '0px' }} src={WhatWeDo} class="card-img-top" alt="..." />
                            <div class="card-body" style={{ paddingTop: '30px', paddingLeft: '0px' }}>
                                <h5 style={{ color: '#333' }} class="card-title py-3">WHAT WE DO</h5>
                                <p style={{ color: "777" }} class="card-text para">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                <p style={{ color: "777" }} class="card-text para">Minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

                            </div>
                        </div>
                    </div>



                </div>
            </div>
            <div className="my-5">
                <h5 style={{ color: '#333' }} class="card-title py-5">OUR TEAM</h5>
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div class="card" style={{ border: '0px' }} >
                            <img style={{ borderRadius: '0px' }} src={TeamOne} class="card-img-top" alt="..." />
                            <div class="card-body" style={{ paddingTop: '5px', paddingLeft: '0px' }}>

                                <div className="py-3">
                                    <h5 style={{ color: '#333' }} class="card-title">James M. Beck</h5>
                                    <p style={{ color: "777" }} class="card-text para"><i>Construction Manager</i></p>
                                </div>

                                <p style={{ color: "777" }} class="card-text para">Donec a felis sed ligula aliquet sollicitudin a in elit. Nunc at commodo erat, fringilla egestas tortor. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>


                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div class="card" style={{ border: '0px' }} >
                            <img style={{ borderRadius: '0px' }} src={TeamTwo} class="card-img-top" alt="..." />
                            <div class="card-body" style={{ paddingTop: '5px', paddingLeft: '0px' }}>
                                <div className="py-3">
                                    <h5 style={{ color: '#333' }} class="card-title">Scooter Libby</h5>
                                    <p style={{ color: "777" }} class="card-text para"><i>Project Manager</i></p>
                                </div>
                                <p style={{ color: "777" }} class="card-text para">Donec a felis sed ligula aliquet sollicitudin a in elit. Nunc at commodo erat, fringilla egestas tortor. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>


                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div class="card" style={{ border: '0px' }} >
                            <img style={{ borderRadius: '0px' }} src={TeamThree} class="card-img-top" alt="..." />
                            <div class="card-body" style={{ paddingTop: '5px', paddingLeft: '0px' }}>

                            <div className="py-3">
                                    <h5 style={{ color: '#333' }} class="card-title">David Boies</h5>
                                    <p style={{ color: "777" }} class="card-text para"><i>Building Worker</i></p>
                                </div>
                            
                                <p style={{ color: "777" }} class="card-text para">Donec a felis sed ligula aliquet sollicitudin a in elit. Nunc at commodo erat, fringilla egestas tortor. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/aboutcompany.jsx